import React, { useState } from 'react';
import CancelButton from '../../../../../../../component/ui/buttons/cancel-button/cancel-button';
import ApproveButtons from '../../../../../../../component/ui/buttons/approve-button/approve-buttons';
import { Calendar } from 'primereact/calendar';
import { EditText } from '../../../../../../../component/ui/edit-text/edit-text';
import { EditNumber } from '../../../../../../../component/ui/edit-text/edit-number';
import { addNewTaskOperation } from './operations/add-new-task-operation';
import { Dropdown } from 'primereact/dropdown';
import globalSettingsStores from '../../../../../../../stores/settings-stores';
import { AssignmentType } from '../../../../../../../api/types/settings/studies/assignment-type';

interface AddEditTaskDialogDataModel {
  onHide: () => any;
}

const AddEditTaskDialog: React.FC<AddEditTaskDialogDataModel> = ({
  onHide,
}) => {
  const [date, setDate] = useState<Date>();
  const [name, setName] = useState('');
  const [points, setPoints] = useState<number>(0);
  const [selectedAssignmentType, setSelectedAssignmentType] =
    useState<AssignmentType | null>(null);

  const handleTaskNameChange = (value: string) => {
    setName(value);
  };

  const handlePointChange = (value: number) => {
    setPoints(value);
  };

  const handleDateChange = (e: any) => {
    if (e.target.value instanceof Date || e.target.value === null) {
      setDate(e.target.value);
    }
  };

  const handleOnApprove = async () => {
    if (!selectedAssignmentType) {
      return;
    }
    await addNewTaskOperation(
      name,
      points,
      date,
      selectedAssignmentType.id,
      onHide,
    );
  };

  return (
    <div>
      <div style={{}}>
        <EditText title={'שם מטלה'} onChange={handleTaskNameChange} />
        <div style={{ marginBottom: '1rem' }}>
          <div
            style={{ fontSize: '14px', color: '#4b5563', marginBottom: '4px' }}
          >
            סוג מטלה
          </div>
          <Dropdown
            value={selectedAssignmentType}
            onChange={(e) => setSelectedAssignmentType(e.value)}
            options={globalSettingsStores.assignmentTypes}
            optionLabel="assignmentTypeName"
            placeholder="בחר סוג מטלה"
            style={{ height: '35px', width: '100%', alignItems: 'center' }}
            required
          />
        </div>
        <EditNumber
          title={'אחוז מהציון הסופי'}
          onChange={handlePointChange}
          defaultValue={0}
          min={0}
          max={100}
        />
        <div>
          <div
            style={{
              fontSize: '14px',
              color: '#4b5563',
            }}
          >
            תאריך אחרון להגשה
          </div>
          <Calendar
            style={{
              height: '36px',
              direction: 'ltr',
              marginTop: '4px',
            }}
            inputStyle={{ textAlign: 'right' }}
            dateFormat={'dd/mm/yy'}
            value={date}
            onChange={handleDateChange}
            showIcon
          />
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'left',
          marginTop: '8px',
        }}
      >
        <CancelButton
          onClick={() => {
            onHide();
          }}
        />

        <div style={{ width: '10px' }} />
        <ApproveButtons onClick={handleOnApprove} />
      </div>
    </div>
  );
};

export default AddEditTaskDialog;
